// extracted by mini-css-extract-plugin
export default {"aboutus-container":"AboutUs_aboutus-container__ZqG7M"};